module.exports = __webpack_public_path__ + "img/shipin_banner_san.55083382.png";